<template>
    <div class="m-editpwd">
        <div class="title_wrap">
            <p class="page_title">{{ $t('login.editPwd') }}</p>
        </div>

        <div class="aside">{{ $t('my.editPwdTip') }}</div>

        <el-form
            ref="pForm"
            :model="pForm"
            :rules="pRules"
            class="m_form"
            auto-complete="on"
            label-position="left"
            label-width="180px"
        >
            <el-form-item
                prop="old_password"
                :label="$t('my.oldPwd')"
            >
                <el-input
                    v-model="pForm.old_password"
                    :type="pwdType"
                    name="old_password"
                    autocomplete="on"
                    auto-complete="off"
                    :placeholder="$t('my.oldPwdTip')"
                    class="m_form_item_input"
                    @keyup.enter.native="submit"
                />
            </el-form-item>

            <el-form-item
                prop="new_password"
                :label="$t('my.newPwd')"
            >
                <el-input
                    v-model="pForm.new_password"
                    :type="pwdType"
                    name="new_password"
                    autocomplete="on"
                    auto-complete="off"
                    :placeholder="$t('my.newPwdTip')"
                    class="m_form_item_input"
                    @keyup.enter.native="submit"
                />
            </el-form-item>

            <el-form-item
                prop="new_password_confirmation"
                :label="$t('my.confirmPwd')"
            >
                <el-input
                    v-model="pForm.new_password_confirmation"
                    :type="pwdType"
                    name="new_password_confirmation"
                    autocomplete="on"
                    auto-complete="off"
                    :placeholder="$t('my.confirmPwdTip')"
                    class="m_form_item_input"
                    @keyup.enter.native="submit"
                />
            </el-form-item>

            <el-form-item>
                <el-button
                    class="form_submit"
                    :loading="saveLoading"
                    size="medium"
                    type="primary"
                    @click.native.prevent="submit"
                >{{ $t('login.editPwd') }}</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import mix_user from '@/views/login/mix_user'
import { password } from '@/api/Auth'

export default {
    name: 'EditPassword',
    components: {},
    mixins: [mix_user],
    data() {
        return {
            saveLoading: false,
            pForm: {
                old_password: '',
                new_password: '',
                new_password_confirmation: ''
            }
        }
    },
    created() {
    },
    methods: {
        submit() {
            this.saveLoading = true
            password(this.pForm).then(res => {
                this.$notify({
                    title: '成功',
                    message: '成功修改',
                    type: 'success',
                    duration: 2000
                })
                this.saveLoading = false
                setTimeout(() => {
                    this.$router.push({ path: '/login', query: { tid: this.tid } })
                }, 1000)
            }).catch(() => { this.saveLoading = false })
        }
    }
}
</script>
<style rel="stylesheet/scss" lang="scss">
.m-editpwd {
    .title_wrap {
        height: 100px;
        border-bottom: 1px solid #eeeeee;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .page_title {
            line-height: 100px;
            font-weight: 400;
            font-size: 24px;
            color: #333;
        }

        .btn_group {
            .primary_btn {
                height: 33px;
            }
        }
    }

    .aside {
        margin: 20px 30px 40px;
        padding: 18px 40px;
        background: #fdf6ec;
        border-radius: 10px;
        line-height: 24px;
        text-align: left;
        font-size: 14px;
        color: #000;
    }

    .m_form {
        width: 550px;
        margin: 0 auto;
        box-sizing: border-box;

        .el-form-item__label {
            text-align: right;
            line-height: 48px;
            font-size: 16px;
            color: #000000;
        }

        .m_form_item_input {
            margin-left: 10px;

            .el-input__inner {
                width: 450px;
                height: 48px;
                border-color: #f2f2f2;
                background: #f2f2f2;
                border-radius: 24px;
            }
        }

        .form_submit {
            margin-top: 40px;
            width: 160px;
            height: 48px;
            line-height: 48px;
            padding: 0 20px;
            box-shadow: 2px 3px 10px 0px rgba(146, 109, 61, 0.29);
            border-radius: 24px;
            font-size: 16px;
            color: #f3f5f4;
        }
    }
}
</style>
